import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { Grid, Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import TableComponent from "app/common/Component/Table/TableComponent";
import IconDelete from "app/common/Icon/IconDelete";
import { getDateTime, hideMiddleDigits, isRoleHisReadOnly } from "app/common/LocalFunction";
import CopyableCodeCell from "app/common/Component/CopyableCodeCell";
import axios from "axios";
import { PatientManagementStore } from "app/PatientManagement/PatientManagementStore";
const ListComplaint = ({data}) => {
    const { t } = useTranslation();
    const {
            pageRegisterComplaint,
            searchComplaint,
            handleChangeFormSearchComplaint
        } = PatientManagementStore.complaintStore;
    return (
        <Grid container spacing={1} >
            <Grid item xs={12}>
                <TableComponent
                    showOrdinalNumbers
                    titleNodata={t("noData")}
                    data={pageRegisterComplaint?.content || []}
                    minWidth={"720px"}
                    name="ComplaintTab"
                    showMoreButton
                    columns={[
                        // {
                        //   title: t("action"),
                        //   field: "action",
                        //   align: "center",
                        //   width: "30px",
                        //   render: (row) => {
                        //     return (
                        //       <div className="flex-center gap-2">
                        //         {row?.status === 1 && (
                        //           <Tooltip title="Xóa khiếu nại" placement="top" arrow>
                        //             <div className="flex">
                        //               <IconDelete />
                        //             </div>
                        //           </Tooltip>
                        //         )}
                        //       </div>
                        //     );
                        //   },
                        // },
                        {
                            title:"Khách hàng",
                            field:"client",
                            width: "300px",
                            render:(row) => {
                                const name = row?.clientName || "";
                                const code = row?.client?.code || "";
                                const phone = row?.clientPhoneNumber || "";
                                return (
                                    <div>
                                    <div>
                                        Tên KH:{" "}
                                        <span style={{color:"#1976d2", cursor:"pointer"}}>
                                            {name}
                                        </span>
                                    </div>
                                    <div>Mã KH: <CopyableCodeCell value={code} size="small" /></div>
                                    <div className="flex flex-middle">
                                        SĐT: &nbsp;
                                        <span
                                            copyContent={phone}
                                            // onClick={() => onOpen ({phoneNumber:phone})}
                                        >
                                        {hideMiddleDigits(phone)}
                                        </span>
                                    </div>
                                    </div>
                                );
                            },
                        },
                        {
                            field: "status",
                            title: t("Bước xử lý"),
                            render: (row) => {
                                const statusMap = {
                                1: "Đang chờ xử lý",
                                2: "Đang xử lý",
                                3: "Đã phản hồi cho KH",
                                4: "Đã kết thúc phản hồi",
                                };
                                return statusMap[row.status] || "Không xác định";
                            },
                        },
                        {
                        title:"Loại phiếu",
                        field:"ticketType.name",
                        },
                        {
                            title:"Nguồn khiếu nại",
                            field:"complaintSource.name",
                        },
                        {
                            title:"Nhóm dịch vụ",
                            field:"productCategory.name",
                        },
                        {
                            field:"agentGroup.name",
                            title:"Nhóm nhân viên tiếp nhận"
                        },
                        {
                            field:"agent.name",
                            title:"Nhân viên tiếp nhận"
                        },
                        {
                            title:"Lịch hẹn",
                            field:"appointment",
                            render:(row) => {
                                const appointmentDate = getDateTime (
                                    row?.appointment?.appointmentDate
                                );
                                // const dayOfWeek = getDayOfWeekInVietnamese (
                                //     row?.appointment?.appointmentDate
                                // );
                                const startTime = getDateTime (row?.appointment?.startTime)
                                const endTime = getDateTime (row?.appointment?.endTime)
                                return (
                                    <div>
                                    {/* <div>{dayOfWeek}</div> */}
                                    <div>{appointmentDate}</div>
                                    <div>{startTime}{endTime? " - " + endTime : ""}</div>
                                    </div>
                                );
                            },
                        },
                        {
                            field: "mainContent",
                            title: t("Nội dung khiếu nại"),
                        },
                        {
                            title:"Cơ sở",
                            field:"department.name",
                        },

                        {
                            title:"Nhân viên phân bổ",
                            field:"assignedAgent.name",
                        },
                        {
                            field:"agentGroupCs.name", 
                            title:"Nhóm nhân viên chăm sóc"
                        },
                        {
                            field:"csAgent.name", 
                            title:"Nhân viên chăm sóc"
                        },
                        {
                            field:"note", 
                            title:"Ghi chú"
                        },
                        {
                            field:"ticketCreateDate",
                            title: "Ngày tạo",
                            render:(rowData) => {
                                    return getDateTime(rowData?.ticketCreateDate);
                                },
                        },
                    ]}
                    dataPagination={{
                            pageIndex: searchComplaint?.pageIndex,
                            pageSize: searchComplaint?.pageSize,
                            totalElements: pageRegisterComplaint?.totalElements,
                            totalPages: pageRegisterComplaint?.totalPages,
                            setPageIndex: (pageIndex) =>
                                handleChangeFormSearchComplaint({ pageIndex }),
                            setPageSize: (pageSize) =>
                                handleChangeFormSearchComplaint({ pageSize }),
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default memo(observer(ListComplaint));
